"use strict";var r=require("../Guard/isNumber.cjs");exports.numberIsNaN=function(e){return r.isNumber(e)&&isNaN(e)};
//# sourceMappingURL=numberIsNaN.cjs.map
